import { takeLatest, call, put } from "redux-saga/effects";
import api from "../../../services/api";
import {
  CREATE_SUGGESTED_COMPETITOR_REQUEST,
  createSuggestedCompetitorSuccess,
  createSuggestedCompetitorFailure,
} from "../actions/suggestedCompetitorActions";
import {
  createSuggestedCompetitor,
  createSuggestedCompetitorNew,
  createUpdateCompetitor,
} from "../../../services/accIqService";

function* createSuggestedCompetitorSaga(action) {
  try {
    const {
      user_id,
      user_type,
      user_role,
      revenue_teardown,
      expected_currency,
      client,
      competitor,
      company_id,
      subdimensions,
      ksCompanies,
      industry,
      remove_subdimensions,
    } = action.payload;

    if (remove_subdimensions !== undefined) {
      yield call(
        createUpdateCompetitor,
        user_id,
        user_type,
        user_role,
        revenue_teardown,
        expected_currency,
        client,
        competitor,
        company_id,
        subdimensions,
        ksCompanies,
        industry,
        remove_subdimensions
      );
    } else {
      yield call(
        createUpdateCompetitor,
        user_id,
        user_type,
        user_role,
        revenue_teardown,
        expected_currency,
        client,
        competitor,
        company_id,
        subdimensions,
        ksCompanies,
        industry
      );
    }
    // yield call(
    //   createUpdateCompetitor,
    //   user_id,
    //   user_type,
    //   client,
    //   competitor,
    //   company_id,
    //   subdimensions,
    //   ksCompanies,
    //   industry,
    //   remove_subdimensions
    // );

    yield put(createSuggestedCompetitorSuccess());
  } catch (error) {
    yield put(
      createSuggestedCompetitorFailure(
        error?.response?.data?.message || "Failed to add competitor"
      )
    );
  }
}

export default function* suggestedCompetitorWatcher() {
  yield takeLatest(
    CREATE_SUGGESTED_COMPETITOR_REQUEST,
    createSuggestedCompetitorSaga
  );
}
